import { Box, Button, Container } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import TabelaAgendamentosPendentes from '../../Components/TabelaAgendamentosPendentes';
import TabelaAvaliacoes from '../../Components/TabelaAvaliacoes';
import { logout } from '../../Services/ApiService';
import { StyledButton } from './styles';

// import { Container } from './styles';
const AreaMonitor: React.FC = () => {


  return (
    <>
      <Header active='AreaDoMonitor'/>
      <Container style={{backgroundColor:'rgba(255,255,255,0.8)',textAlign:'center', padding:'1rem', display:'flex', flexDirection:'column'}} maxWidth="lg">
        <h2 style={{padding:'1rem'}} >Bem-Vindo(a) Monitor(a)</h2>
        <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'center'}}>
          <Link style={{color: 'inherit', textDecoration: 'inherit'}} to='/AreaDoMonitor/SessoesPresenciais'>
            <StyledButton>
              Sessões Presenciais
            </StyledButton>
          </Link>
          <Link style={{color: 'inherit', textDecoration: 'inherit'}} to='/AreaDoMonitor/SessoesVirtuais'>
            <StyledButton>
              Sessões Virtuais
            </StyledButton >
          </Link>
        </div>
        <Link style={{color: 'inherit', textDecoration: 'inherit'}} to='/AreaDoMonitor/Relatorio'>
          <Button variant="contained" >
            Gerar Relatório
          </Button>
        </Link>
        <div style={{margin:'20px 0px'}}></div>
        <TabelaAgendamentosPendentes/>
        <div style={{margin:'20px 0px'}}></div>
        <TabelaAvaliacoes/>
        <Box sx={{display:'flex', flexDirection:'column', flexWrap:'wrap',justifyContent:'center'}}>
          <Button style={{margin:'1rem'}} variant="contained" color="error" onClick={logout}>Sair</Button>
        </Box>
      </Container>
      <Footer/>
    </>
  );
}

export default AreaMonitor;